<template>
    <div class="input-group" :style="fieldStyles(input_mask)">
      <field-icon :fieldData="fieldData"></field-icon>

      <the-mask
      :disabled="(!!showDisabled())"
      :name="fieldData.field_name"
      :aria-describedby="`${fieldData.field_name}_describedby`"
      :id="fieldData.field_name"
      type="text"
      placeholder="MM/DD/YYYY"
      v-model="fieldData.field_value"
      :mask="input_mask"
      size="13"
      autocomplete="off"
      @blur.native="apiRule.present && apiRule.type == 'onblur' ? postRule($event.target.value, fieldData) : ''"
      :masked="true"
      v-validate="field_rules"
      v-bind:class="{'form-control': true,
        'error': errors.has(fieldData.field_name) || fieldData.has_error}">
      </the-mask>
      <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  directives: { mask },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  mixins: [inputFieldMixin],
  components: { FieldIcon },
  data() {
    return {
      input_mask: '##/##/####',
    };
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputDatelong.vue?43d50324